<div class="tender-meta-card">
  <p class="tender-meta-card__label">{{ label() | translate }}</p>
  <p class="tender-meta-card__value" [class]="valueClass()">{{ value() }}</p>
</div>
